export default __webpack_public_path__ + "static/1090-ab7a586c6d693d3de80a1a93bb650333.gif";